import { gql } from "@apollo/client";


export const GET_REMAIN_STOCK = gql`
    query GetRemainListMaterialUnitQty(
        $warehouseId: ID, 
        $listMaterialUnitId: ID
    ) {
        getRemainListMaterialUnitQty(
            warehouseId: $warehouseId
            listMaterialUnitId: $listMaterialUnitId
        ) {
            remainInSmallUnit
            averagePrice
        }
    }
`;